import React  from 'react';
import {  CardFooter } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';
import { useSelector } from 'react-redux'

import './Tabs.css';


const CourseSubjectsSchedule = ( isLoading ) =>  {

  let minHour = 7;
  let maxHour = 18;
 
  
  const { subjects } = useSelector( state => ({
      token: state.auth.session.jwt_token, 
     course: state.courses.course,
   subjects: state.courses.courseSubjects
    
   }))

    let agenda = {} 
    subjects && subjects.map( (subject ) => {
            subject.schedule.map( (sch, idx) => {
                let franja = parseInt( sch.start_time.slice(0,2), 10) ;
                if ( !agenda[franja] ) agenda[franja] = [[],[],[],[],[],[],[]] ;
                agenda[franja][parseInt(sch.week_day,10)].push ( 
                            { start_time: sch.start_time, 
                                end_time: sch.end_time, 
                                    name: subject.long_name,
                             display_fmt: sch.start_time.slice(0,5) + " - " + sch.end_time.slice(0,5) + ": " +  subject.long_name
                                })
                return null;
                            }
            )
            return null;
        }
    )

    const formatSchedule = ( sch ) => {
        return <div><b> { sch.start_time.slice(0,5) + " - " + sch.end_time.slice(0,5) } </b> { sch.name }</div> ;
    }

    var rows = [];
    for (var i = minHour; i <= maxHour ; i++) {
        let dev = <tr> <td>{i}:00</td> 
                    <td>{agenda[i] && agenda[i]['2'] && agenda[i]['2'].map( sch => { return formatSchedule ( sch ) } )}</td> 
                    <td>{agenda[i] && agenda[i]['3'] && agenda[i]['3'].map( sch => { return formatSchedule ( sch ) } )}</td> 
                    <td>{agenda[i] && agenda[i]['4'] && agenda[i]['4'].map( sch => { return formatSchedule ( sch ) } )}</td> 
                    <td>{agenda[i] && agenda[i]['5'] && agenda[i]['5'].map( sch => { return formatSchedule ( sch ) } )}</td> 
                    <td>{agenda[i] && agenda[i]['6'] && agenda[i]['6'].map( sch => { return formatSchedule ( sch ) } )}</td> 
                </tr> ;


        rows.push( dev )
        }
    

        return (
            <>
            <CardFooter>
               <table class="agenda">
                    <thead>
                        <tr>
                            <td style={{width: '10%'}}>
                                {!subjects && <Spinner  />} 
                            </td>
                            <td>Lunes</td> 
                            <td>Martes</td>
                            <td>Miércoles</td>
                            <td>Jueves</td>
                            <td>Viernes</td>
                        </tr>
                    </thead>
                    { rows }
                    
                </table>
               



            </CardFooter>
            </>

            )
  };
  

export { CourseSubjectsSchedule } ;
